import * as React from "react";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import { Box, Typography } from "@mui/material";

function createData(activity, activity_percent, intensity, intensity_percent) {
  return { activity, activity_percent, intensity, intensity_percent };
}

export default function T1ActivityIntensity({ data }) {

  const merged =
    data?.metScoreBreakDown?.map((item) => {
      const match = data?.intensities?.find(
        (int) => int.activityType === item.activityType
      );
      return {
        ...item,
        intensity: match ? match.intensity : null,
      };
    }) || [];

  const rows = merged.map((d) =>
    createData(
      d.activityType,
      d.percentage||0,
      d.activityType,
      d.intensity
    )
  );

  return (
    <TableContainer sx={{ background: "transparent", pl: 1, overflowX: "auto", maxWidth: "100%" }}>
      <Table
        sx={{ minWidth: "100%", background: "transparent", height: 100 }}
        aria-label="simple table"
      >
        <TableHead>
          <TableRow
            sx={{
              "& td, & th": {
                border: 0,
                py: 1,
                lineHeight: 1.2,
                fontSize: "13px",
              },
            }}
          >
            <TableCell>T1</TableCell>
            <TableCell align="left">
              <Box
                component="span"
                sx={{
                  backgroundColor: "#DDEEFD",
                  p: 1,
                  borderRadius: "10px",
                  display: "inline-block",
                  fontSize:'13px',
                  fontFamily: 'Roboto Flex'
                }}
              >
                Activity Type
              </Box>
            </TableCell>
            <TableCell align="right">
              <Box
                component="span"
                sx={{
                  backgroundColor: "#DDEEFD",
                  p: 1,
                  borderRadius: "10px",
                  display: "inline-block",
                  fontSize:'13px',
                  fontFamily: 'Roboto Flex'
                }}
              >
                %
              </Box>
            </TableCell>
            <TableCell align="left">
              <Box
                component="span"
                sx={{
                  backgroundColor: "#DDEEFD",
                  p: 1,
                  borderRadius: "10px",
                  display: "inline-block",
                  fontSize:'13px',
                  fontFamily: 'Roboto Flex'
                }}
              >
                Intensity
              </Box>
            </TableCell>
            <TableCell align="right">
              <Box
                component="span"
                sx={{
                  backgroundColor: "#DDEEFD",
                  p: 1,
                  borderRadius: "10px",
                  display: "inline-block",
                  fontSize:'13px',
                  fontFamily: 'Roboto Flex'
                }}
              >
                %
              </Box>
            </TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {rows.map((row) => (
            <TableRow
              key={row.name}
              sx={{
                "& td, & th": {
                  border: 0,
                  py: 1,
                  lineHeight: 1.2,
                  fontSize: "14px",
                },
              }}
            >
              <TableCell component="th" scope="row">
                {}
              </TableCell>
              <TableCell align="left">{row.activity}</TableCell>
              <TableCell align="right">{row.activity_percent}</TableCell>
              <TableCell align="left">{row.intensity}</TableCell>
              <TableCell align="right">{row.intensity_percent}</TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
}
